import { useState } from "react";
import { Button, Field, Modal, useToast } from "../../components";
import { useChangePassword } from "../../api/users";
import { errorMessage } from "../../lib/format";

/** Change the signed-in user's password (topbar "Password" button). */
export function ChangePasswordModal({ onClose }: { onClose: () => void }) {
  const toast = useToast();
  const change = useChangePassword();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");

  const mismatch = confirm.length > 0 && next !== confirm;
  const tooShort = next.length > 0 && next.length < 8;
  const ready = current && next.length >= 8 && next === confirm && !change.isPending;

  const submit = () => {
    change.mutate(
      { currentPassword: current, newPassword: next },
      {
        onSuccess: () => {
          toast.push({ message: "Password changed.", tone: "ok" });
          onClose();
        },
        onError: (error) => toast.push({ message: errorMessage(error), tone: "danger" }),
      },
    );
  };

  return (
    <Modal
      open
      title="Change password"
      sub="applies to your account only"
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" disabled={!ready} onClick={submit}>
            {change.isPending ? "Saving…" : "Change password"}
          </Button>
        </>
      }
    >
      <div className="stack">
        <Field label="Current password">
          <input
            className="field"
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(event) => setCurrent(event.target.value)}
          />
        </Field>
        <Field label="New password" error={tooShort ? "At least 8 characters." : undefined}>
          <input
            className="field"
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(event) => setNext(event.target.value)}
          />
        </Field>
        <Field label="Confirm new password" error={mismatch ? "Passwords don't match." : undefined}>
          <input
            className="field"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
          />
        </Field>
      </div>
    </Modal>
  );
}
